import {
  add,
  parse,
  getDay,
  format,
  isToday,
  isEqual,
  isSunday,
  parseISO,
  isSameDay,
  endOfMonth,
  isSameMonth,
  previousMonday,
  eachDayOfInterval
} from "date-fns"
import { nextSunday } from "date-fns/esm"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"

let colStartClasses = [
  "col-start-7",
  "",
  "col-start-2",
  "col-start-3",
  "col-start-4",
  "col-start-5",
  "col-start-6"
]

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

export default function Calendar({
  meetings,
  selectedDay,
  currentMonth,
  setSelectedDay,
  setCurrentMonth,
  setInfoMessage,
  requireInfoMessage
}) {
  let firstDayCurrentMonth = parse(currentMonth, "MMM-yyyy", new Date())

  let days = eachDayOfInterval({
    start: previousMonday(firstDayCurrentMonth),
    end: nextSunday(endOfMonth(firstDayCurrentMonth))
  })

  function previousMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 })
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"))
  }

  function nextMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 })
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"))
  }

  return (
    <div className="w-full">
      <div className="flex items-start justify-between pl-3 pr-2">
        <p className="font-medium text-neutral-1d">
          {format(firstDayCurrentMonth, "MMMM yyyy")}
        </p>
        <div className="button-group flex gap-7">
          <button
            type="button"
            onClick={previousMonth}
            className="text-neutral-1"
          >
            <FiChevronLeft className="h-6 w-6" aria-hidden="true" />
          </button>
          <button onClick={nextMonth} type="button" className=" text-neutral-1">
            <FiChevronRight className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-7 pt-6 text-center text-[13px] text-neutral-7">
        <div>M</div>
        <div>T</div>
        <div>W</div>
        <div>T</div>
        <div>F</div>
        <div>S</div>
        <div>S</div>
      </div>

      <div className="subtitle-2 grid grid-cols-7 pt-1">
        {days.map((day, dayIdx) => {
          const assessment = {
            color: "",
            date: "",
            info: []
          }

          for (let item of meetings) {
            if (isSameDay(parseISO(item.date), day)) {
              if (assessment.info.length === 0 && isToday(day))
                assessment.info.push("This is the current day")
              assessment.color = item.color
              assessment.date = item.date
              assessment.info.push(item.info)
            }
          }

          return (
            <div
              key={day.toString()}
              className={classNames(
                dayIdx === 0 && colStartClasses[getDay(day)],
                "py-1"
              )}
            >
              <button
                type="button"
                onClick={() => {
                  setSelectedDay(day)
                  requireInfoMessage && setInfoMessage(assessment.info)
                }}
                className={classNames(
                  // If a day is selected, make the bg dark, text white and ignore the current day
                  isEqual(day, selectedDay) &&
                    !isToday(day) &&
                    "bg-gray-900 text-white",

                  // If dates are not from same month, fade them out
                  !isSameMonth(day, firstDayCurrentMonth) && "  text-neutral-7",

                  // Make sunday background gray
                  !isEqual(day, selectedDay) &&
                    isSunday(day) &&
                    !isSameDay(parseISO(assessment.date), day) &&
                    "bg-[#F5F5F9]",

                  !isToday(day) &&
                    isSameDay(parseISO(assessment.date), day) &&
                    "bg-[" + assessment.color + "] text-white",
                  // for removal of current date
                  isToday(day) &&
                    isSameDay(parseISO(assessment.date), day) &&
                    "bg-[" + assessment.color + "] text-white",

                  // For current day, make the bg primary, text white.
                  // isEqual(day, selectedDay) &&
                  //   isToday(day) &&
                  //   "bg-[#06D79E] text-white",

                  // // If any other day except today is selected, keep bg of today blue and text white
                  // !isEqual(day, selectedDay) &&
                  //   isToday(day) &&
                  //   "bg-[#06D79E] text-white",

                  "mx-auto flex h-[26px] w-[26px] items-center justify-center rounded-[5px] text-neutral-1"
                )}
              >
                <time
                  dateTime={format(day, "yyyy-MM-dd")}
                  className="text-[13px]"
                >
                  {format(day, "d")}
                </time>
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
